import { WMButton, WMButtonVariant } from '@walkme/wm-ui';
import React from 'react';
import classes from './EmptyState.module.scss';
import cc from 'classcat';

const EmptyState = ({
    title,
    description,
    actionText,
    image,
    onClick,
    noMaxHeight = false
}: {
    title?: string;
    description?: string;
    actionText?: string;
    image?: string;
    onClick?: () => void;
    noMaxHeight?: boolean;
}) => {
    return (
        <div className={cc([classes.root, { [classes.noMaxHeight]: noMaxHeight }])} data-testid={'empty-state'}>
            {image && <img className={classes.emptyImg} src={image} />}
            <span className={classes.title}>{title}</span>

            {description && (
                <span className={classes.description}>
                    {description}{' '}
                    {onClick && actionText && (
                        <WMButton className={classes.link} variant={WMButtonVariant.Text} onClick={onClick}>
                            {actionText}
                        </WMButton>
                    )}
                </span>
            )}
        </div>
    );
};

export default EmptyState;
